// extracted by mini-css-extract-plugin
export default {"container":"SandboxIntegrationReAuth_container__igK6q","icon":"SandboxIntegrationReAuth_icon__khsLL"};